import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VTooltip from 'v-tooltip'
import VueGtm from 'vue-gtm'
import money from 'v-money'
import { registerGlobalComponents } from '@/global-components'
import '@/walkthroughs/wt'
import VueGtag from 'vue-gtag'
import VueShepherd from 'vue-shepherd'
import { functions } from './functions'
import StickyElem from './directives/sticky-elem'
import './filters'
import * as Sentry from '@sentry/vue'
import versionChecker from './plugins/version-checker'
import Inputmask from 'inputmask'
import { installSafeSetAttribute } from '@/helpers/attr-value'

installSafeSetAttribute()

require('./styles/main.scss')
require('moment/locale/pl')

// plugins
Vue.use(versionChecker)

// functions
Vue.prototype.$functions = functions

Vue.prototype.$brand = require('../src/layouts/' +
    process.env.VUE_APP_BRAND +
    '.json')

Vue.use(VueShepherd)

// GTAG
Vue.use(VueGtag, {
    config: { id: 'UA-142398529-6' }
})

// GTM
Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTAG,
    queryParams: {},
    defer: false,
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false
})

Vue.use(money, {
    decimal: '.',
    thousands: ' ',
    precision: 2,
    mask: true
})

// scrollto
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

// register global components
registerGlobalComponents()

Vue.use(require('vue-moment'))

Vue.use(VTooltip, {
    defaultTrigger: 'click hover focus'
})

Vue.directive('mask', {
    bind: function(el, binding) {
        if (!binding.value) return
        Inputmask(binding.value).mask(el)
    },
    update: function(el, binding) {
        if (!binding.value) return
        if (JSON.stringify(binding.value) === JSON.stringify(binding.oldValue)) return

        Inputmask(binding.value).mask(el)
    }
})

Vue.config.productionTip = false

// add click-outside directive
Vue.directive('click-outside', {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            // here I check that click was outside the el and his childrens
            if (!(el === event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event)
            }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    }
})

// add sticky-elem directive
Vue.directive('sticky-elem', StickyElem)
;(async () => {
    // save vuex init state
    const initialState = store.state
    await store.$storage.setItem('initialState', initialState)

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')

    //  register service worker
    if ('serviceWorker' in navigator) {
        if (process.env.VUE_APP_MODE !== 'development') {
            navigator.serviceWorker.register(
                `${process.env.BASE_URL}service-worker.js`,
                { updateViaCache: 'none' }
            )
        }
    }
})()

Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        'localhost',
        'https://panel.europlatform.pl',
        'https://panel-backend-dev.europlatform.pl'
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.VUE_APP_SENTRY_ENV
})
